<template >
    <div onclick="">
        <Header currentpage="home" />

        <section id="hero" class="section scrollspy">
        <div  class="row row-bottom-0" style="background-color:#223F59">
        <div class="row row-bottom-0">
            <div class="s12 m12 l12 center" style="background-color:#223F59;">
                <video id="homepage-video" class="col l6 hero-video responsive-video hide-on-small-and-down " autoplay muted loop>                      
                        <source src="assets/video/Zapy-Intro.mp4" type="video/mp4">                       
                        VIDEO not supported
                </video>
                <div class="hide-on-med-and-up mobile-background">

                </div>
                <div class="hero-content center">
                    <h1>Digitize Your Event Experience</h1>
                    <span>Impress your attendees and capture their interactions</span><br/>
                    <a id="start-btn" href="#wow" class="btn btn-large" @click="clickStart" >Start Now</a> <br/>
                    <div class="home-downarrow">
                    <img src="/assets/img/down_arrow.svg" />
                    </div>
                </div>
    
            </div>
        </div>        
        </div>
        </section>
       
        <div class="row row-bottom-0 wow-factor-bg phonebg">
            <div   class="s12 m12 l12 center " >
                 <div id="wow" class="section scrollspy" style="padding-bottom:1rem;">
                <div class="wow-factor-section">
                <div class="wow-factor">Give your events the WOW factor<br/> <span style="font-size:25px;">with the following Zapy features</span></div>
                <div class="row row-bottom-0">
                    <div>
                        <Product url='assets/img/Registration.png' title="Themed On-Site Registration" 
                        description="Delight your event attendees with easy on-site registration"
                        point1="Online registration made easy"
                        point2="Capture CRM data at event entry"
                        point3="A White-Label solution" />
                    </div>
                </div>
                <div class="row row-bottom-0">
                    <div>
                        <Product url='assets/img/Welcome.png' 
                        title="Personalized Welcome Experience"
                        description="Greet your guests with personalized messages"
                        point1="Seamless welcome experience"
                        point2="Customizable digital board"
                        point3="Personalized information"  />
                    </div>
                </div>
                <!-- <div class="row row-bottom-0">
                    <div>
                        <Product url='assets/img/SocialMedia.png' 
                        title="Social Media Activation"
                        description="Increase interactions with your brand on Social Media"
                        point1="Optimize social media buzz"
                        point2="Tap to check-in and post"
                        point3="Completely themeable" />
                    </div>
                </div> -->
                <div class="row row-bottom-0">
                    <div>
                        <Product url='assets/img/Booth.png' 
                        title="Booth Activation"
                        description="Deliver relevant content at the right time"
                        point1="Reach your customers when they are ready"
                        point2="Collect CRM data"
                        point3="Achieve behavioral-based trigger marketing" />
                    </div>
                </div>
                <div class="row row-bottom-0">
                    <div>
                        <Product url='assets/img/LuckyDraw.png' 
                        title="Themed Games" 
                        description="Encourage audience participation with interactive games"
                        point1="Add an element of fun"
                        point2="Simply tap to play"
                        point3="Increase engagement"/>
                    </div>
                </div>
                <div class="row">
                    <div>
                        <Product url='assets/img/Rewards.png' 
                        title="Activity Points Redemption"
                        description=" Increase in-event interactions with activity points redemption"
                        point1="Tap to redeem rewards"
                        point2="Increase engagement at your event"
                        point3="Positive event interaction" />
                    </div>
                </div>                
               </div>
               </div>
                <div id="themeable" class="row row-bottom-0 complete-themeable section scrollspy ">
                    <div class="themeable-img-mask">
                        <img src="/assets/img/complete_themeable.svg" />
                    </div>
                    <div class="completely-themeable-header">
                        Completely themeable
                    </div>
                    <div class="completely-themeable-description">
                        Let your events reflect your brand
                    </div>
                    <div class="completely-themeable-description">Save time and money with Zapy's white-label solution</div>
                </div>
               
            </div>
        </div>
       

        <section id="track" class="section scrollspy">
        <div class="row row-bottom-0">
    
            <div class="track-in-event-bg">
                <div class="s12 m12 l12 center">
                    <div class="track-in-event-title">
                        'Track in-event data and capture<br/>
                        physical human interactions'
                    </div>
                    <div class="track-in-event-sub-title">
                        Enhance your sponsorship value - let's talk
                    </div>
                    <div class="track-event-start-btn">
                        <router-link id="track-event-start-btn" class="btn btn-large" to="/partner" >Start Now</router-link>
                      <!-- <a id="track-event-start-btn"  href="#sell" class="btn btn-large">Start Now</a> -->
                    </div>
                </div>
            </div>
    
        </div>
        </section>


        <section id="sell" class="section scrollspy">
        <div class="row row-bottom-0">    
            <div class="sell-at-the-right-time-bg">
                <div class="s12 m12 l12 center">
                    <div class="sell-at-the-right-time-title">
                        Sell at the right time
                    </div>
                    <div class="sell-at-the-right-time-sub-title ">
                        With Action Trigger Marketing, you can grow your audience and nurture sales
                        by delivering the right message, at the right time, to the right customers.
                    </div>
                    <div class="rectangle " >
                              <div >
                        <div class="example-scenario">
                            Example Scenario
                        </div>
                        <div class="exp-scenario-desp">
                            Tom is interested in your product, so he taps his
                            wristband at your booth. Tom will receive an email or an
                            SMS about your product, moments after the interaction.
                        </div>     
                    </div>           
                    </div>
                      
                    
                    <div class="center">                       
                        <div class="carousel-container">
                            <div class="hide-on-med-and-down">
                                <carousel-3d :autoplay="false" 
                                :autoplay-timeout="5000" 
                                :height="350" 
                                :width="750" 
                                :perspective="0" 
                                :space="700" 
                                :display="3" 
                                :controls-visible="true">
                                    <slide :index="0">
                                    <img src="assets/img/Zapy_4.png" style="object-fit:cover;object-position:center;">
                                    </slide>
                                    <slide :index="1">
                                    <img src="assets/img/Zapy_1.png" style="object-fit:cover;object-position:center;">
                                    </slide>
                                    <slide :index="2">
                                    <img src="assets/img/Zapy_2.png" style="object-fit:cover;object-position:center;">
                                    </slide>
                                    <slide :index="3">
                                    <img src="assets/img/Zapy_3.png" style="object-fit:cover;object-position:center;">
                                    </slide>                                    
                                    <slide :index="4">
                                    <img src="assets/img/Zapy_5.png" style="object-fit:cover;object-position:center;">
                                    </slide>
                                </carousel-3d>
                            </div>
                            <div class="hide-on-large-only">
                                <carousel-3d 
                                :autoplay="false" 
                                :autoplay-timeout="5000" 
                                :height="400" 
                                :width="800" 
                                :perspective="0" 
                                :space="400" 
                                :display="1" 
                                :disable3d="true"
                                :controls-visible="true" 
                                 >
                                    <slide :index="0">
                                    <img src="assets/img/Zapy_4.png" style="object-fit:cover;object-position:center;">
                                    </slide>
                                    <slide :index="1">
                                    <img src="assets/img/Zapy_1.png" style="object-fit:cover;object-position:center;">
                                    </slide>
                                    <slide :index="2">
                                    <img src="assets/img/Zapy_2.png" style="object-fit:cover;object-position:center;">
                                    </slide>
                                    <slide :index="3">
                                    <img src="assets/img/Zapy_3.png" style="object-fit:cover;object-position:center;">
                                    </slide>                                    
                                    <slide :index="4">
                                    <img src="assets/img/Zapy_5.png" style="object-fit:cover;object-position:center;">
                                    </slide>
                                </carousel-3d>
                            </div>
                        </div>
                    </div>   
                    <div class="center">
                        <div class="do-not-lose-your-data">
                            Don't lose your data, use your data
                        </div>
                    </div>   
                    <div class="center" style="padding-bottom:40px;">
                        <div class="row row-bottom-0">
                            <div class="col s12 m12 l6 graph-bg">
                                
                            </div>
                            <div class="col s12 m12 l6">
                                
                                
                                <div class="row" style="margin-bottom:75px !important;">
                                    <div class="col s12 m12 l12">
                                        <div class="gather-insights-and" >
                                            <div style="font-family:Overpass-Bold;font-size:20px;">Gather insights and re-marketable data </div>
                                            from all customer touchpoints, summarized into
                                            one powerful dashboard.
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="row" style="margin-bottom:75px !important;">
                                    <div class="col s12 m12 l12 ">
                                        <div class="view-your-overall-ev">
                                            <div style="font-family:Overpass-Bold;font-size:20px;">View your overall event statistics </div>
                                            and dive into your customer's in-event behavior.
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="margin-bottom:75px !important;">
                                    <div class="col s12 m12 l12 ">
                                        <div class="optimize-your-unders">
                                        <div style="font-family:Overpass-Bold;font-size:20px;">Optimize your understanding of your customers</div>
                                        whether it's their interests, booth interactions,
                                        spendings or other interesting data.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>              
                </div>
            </div>
        </div>
        </section>
        
         <section id="contactus" class="section scrollspy">
        <div class="row row-bottom-0 agency-bg">
            <div class="col s12 m12 l12 center">
                <div class="are-you-an-agency-or">Are you an agency or a brand?</div>
                <div class="digitize-your-events">Start digitizing your event with Zapy</div>
                <div>
                    <!-- <a class="btn btn-flat btn-large btn-learn-how" >Learn How</a> -->
                    <router-link class="btn btn-flat btn-large btn-learn-how" to="/partner">Learn How</router-link>
                </div>
            </div>
        </div>
       
        <Footer />
        </section>

        <div class="col hide-on-med-and-down m3 l2 scrollspy-position">
        <ul id="indicator" class="section table-of-contents">            
            <li ><a  href="#hero"><hr class="scrollspy-line"/></a></li>
            <li><a href="#wow"><hr class="scrollspy-line"/></a></li>         
            <li><a  href="#themeable"><hr class="scrollspy-line"/></a></li>             
            <li><a href="#track"><hr class="scrollspy-line"/></a></li>
            <li><a href="#sell"><hr class="scrollspy-line"/></a></li>
            
        </ul>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Product from "@/components/shared/products.vue";
import { Carousel3d, Slide } from "vue-carousel-3d";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    Product,
    Carousel3d,
    Slide
  },
  created() {
    // var scrollOffsetPerView;
    //GOOGLE SEO
    document.title = "ZAPY - Digitize Your Event";
    document.head.querySelector("meta[name=description]").content =
      "Digitize your event experience. Give your events the wow factor while capturing insightful event interaction data.";

    //eslint-disable-next-line
    // console.log('Window Width', window.innerWidth)

      if (window.innerWidth >= 992)
         this.scrollSpayMethod(520); 
      else this.scrollSpayMethod(25); 
   
  },
  mounted() {
    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll(".carousel");
      var options = {
        fullWidth: false,
        indicators: false
      };
      //eslint-disable-next-line
      var instances = M.Carousel.init(elems, options);
    });
  },
  methods: {
    scrollSpayMethod(offset) {
      //Activate Scroll Spy
      setTimeout(function() {
        var scrolloptions = {
          activeClass: "scrollspy-active",      
          scrollOffset: offset,
          getActiveElement: function(id) {
            var element = document.getElementsByClassName("scrollspy-line");
            for (var i = 0; i < element.length; i++) {
              if (id === "hero" || id === "track") {
                element[i].className = "scrollspy-line scrollspy-show";
                element[i].className += " scrollspy-color-white";
              } else if (id === "contactus") {
                element[i].className = "scrollspy-line scrollspy-hide";
              } else {
                element[i].className = "scrollspy-line scrollspy-show";
                element[i].className += " scrollspy-color-blue";
              }
            }

            return 'a[href="#' + id + '"]';
          }
        };
        var scrollelem = document.querySelectorAll(".scrollspy");
        //eslint-disable-next-line
        var scrollinstance = M.ScrollSpy.init(scrollelem, scrolloptions);
      }, 500);
    },
    clickStart() {
     
    }
  }
};
</script>